<bn-web-ui-card
  heading="Choose the plan that fits your needs"
  [noBorder]="true"
  [noShadow]="true">
  <div class="bn-container--md">
    Whether you need essential protection or advanced features, our Basic, Advanced and Business plans are designed to meet your website's unique security
    requirements. Need something more? Contact Sales for Enterprise. security requirements.
  </div>
  <div class="mt-5 shield-pricing__plan">
    <div class="row shield-pricing__table g-0">
      <div class="col title-col">
        <div class="border-none"></div>
        <div class="cell title-cell">
          Base WAF rules<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Up to 255 built-in rules, and an AI-powered learning mode (Shield AI) for proactive threat detection." />
        </div>
        <div class="cell title-cell">
          Custom WAF rules<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Define granular security controls tailored to your application’s unique needs, with the flexibility to craft precise logic that blocks evolving threats in real time." />
        </div>
        <div class="cell title-cell">
          Rate limit rules<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Manage traffic in real time and address unique surges or patterns with highly customizable rate-limit configurations." />
        </div>
        <div class="cell title-cell">
          Clean requests per month<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="The number of legitimate, threat-free requests your application can serve each month, automatically filtered through our global protection systems. All plans include a generous monthly quota, with seamless scalability via overages as low as just $0.05 per million requests." />
        </div>
        <div class="cell title-cell">
          OWASP top 10 protection<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Stay protected against the industry’s most critical web security risks with preconfigured defenses aligned to the OWASP Top 10, continuously updated to address modern attack patterns." />
        </div>
        <div class="cell title-cell">
          WAF learning mode<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Gain visibility into triggered rules with detailed diagnostics and AI-backed recommendations, empowering smarter decisions on whether to block, log, or allow traffic-all within a transparent, guided workflow." />
        </div>
        <div class="cell title-cell">
          Block & challenge page<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Deliver a seamless user experience during challenges or blocks by fully white-labeling the response pages-replacing bunny.net branding with your own, down to the last detail." />
        </div>
        <div class="cell title-cell">
          Body inspection limits<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Request and response body inspection is limited by plan-up to 256KB on Basic, 1MB on Advanced, and 2MB+ on Enterprise-allowing deeper threat analysis at higher tiers." />
        </div>
        <div class="cell title-cell">
          Bot mitigation<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Benefit from AI-driven analysis to distinguish legitimate automation from malicious traffic, maintaining seamless user experiences." />
        </div>

        <div class="cell title-cell">
          Curated threat access lists<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Continuously maintained by our security team, these dynamic lists provide real-time protection against known threat sources, including botnets, scrapers, proxy networks, datacenters, VPNs, and Tor exit nodes, so you can block malicious traffic before it ever reaches your application." />
        </div>

        <div class="cell title-cell">
          Custom access lists<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Define your own traffic policies with custom IP, CIDR, ASN, or country-based lists. Whether you need to block, challenge, allow, or log requests, Custom access lists give you full control over who can, and can’t, reach your application." />
        </div>

        <div class="cell title-cell">
          Upload scanning<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Scans uploaded files in real time to detect and block malicious or inappropriate content." />
        </div>

        <div class="cell title-cell">
          File scans per month<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Monthly allowance of file scans included with your plan. Higher tiers offer larger limits and lower overage rates." />
        </div>

        <div class="cell title-cell">
          API Guardian<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Protects your APIs with real-time schema validation and basic authentication checks, blocking malicious or unexpected behavior before it reaches your origin." />
        </div>
        <div class="cell title-cell">
          Expert managed DDoS rules<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Leverage continuously updated DDoS mitigation logic curated by experts, offering proactive protection against evolving volumetric, protocol, and application-layer attacks." />
        </div>
        <div class="cell title-cell">
          Zero-Day threat protection<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Shield your applications from previously unknown vulnerabilities with behavior-based defenses that detect and neutralize novel threats before traditional signatures exist." />
        </div>
        <div class="cell title-cell">
          Expert-Led Security Onboarding<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Gain a specialized security resource who provides a week of hands-on onboarding assistance, configures tailored defenses, and offers on-call expertise whenever threats arise." />
        </div>
        <div class="cell title-cell border-bottom">
          Enhanced SLAs<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            tooltip="Enjoy tailored service-level agreements that focus on Time to Mitigation, Uptime, and Custom DDoS Rules, ensuring swift responses and maximum operational reliability." />
        </div>
      </div>
      <div
        class="col"
        [ngClass]="{ selected: selectedShieldPackage === planType.Basic }">
        <div
          class="header-cell"
          [ngClass]="{ selected: selectedShieldPackage === planType.Basic }">
          <div class="position-relative w-100">
            @if (selectedShieldPackage === planType.Basic) {
              <bn-web-ui-badge
                color=""
                contentClass="position-absolute start-50 translate-middle-x shield-plan-selected-badge"
                >Selected</bn-web-ui-badge
              >
            }
            <p class="text-400-semi-bold mb-0">Basic</p>
          </div>
          <div class="mb-4">
            @if (!userStore.hidePricing()) {
              <span class="pricing">Free</span>
            }
          </div>
          <button
            bn-web-ui-button
            size="sm"
            [disabled]="selectedShieldPackage === planType.Basic || false"
            [itemStyle]="'stroke'"
            [loading]="isUpdating()"
            [ngClass]="{ 'd-none': selectedShieldPackage === planType.Basic }"
            (click)="onChoosePackage(planType.Basic)">
            Downgrade
          </button>
        </div>
        <div class="cell">71</div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell">2</div>
        <div class="cell p-0 d-flex flex-column justify-content-center">
          25M inc.
          @if (!userStore.hidePricing()) {
            <div class="text-50-regular text-dark-7">$0.70/million overage</div>
          }
        </div>
        <div class="cell">Basic</div>
        <div class="cell">Basic</div>
        <div class="cell">bunny.net branded</div>
        <div class="cell">256KB</div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell">1 list, 1k entries</div>
        <div class="cell">CSAM</div>
        <div class="cell p-0 d-flex flex-column justify-content-center">
          250K inc.
          @if (!userStore.hidePricing()) {
            <div class="text-50-regular text-dark-7">$0.70/million overage</div>
          }
        </div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell last-item">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
      </div>
      <div
        class="col"
        [ngClass]="{ selected: selectedShieldPackage === planType.Advanced }">
        <div
          class="align-items-center header-cell"
          [ngClass]="{ selected: selectedShieldPackage === planType.Advanced }">
          <div class="position-relative w-100">
            @if (selectedShieldPackage === planType.Advanced) {
              <bn-web-ui-badge
                color=""
                contentClass="position-absolute start-50 translate-middle-x shield-plan-selected-badge"
                >Selected</bn-web-ui-badge
              >
            }
            <p class="text-400-semi-bold mb-0">Advanced</p>
          </div>
          <div class="mb-3">
            @if (!userStore.hidePricing()) {
              <span class="pricing">$9.50 </span>
            }
            @if (!userStore.hidePricing()) {
              <div class="text-100-regular text-dark-7 pricing-per-month">month / per pull zone</div>
            }
          </div>
          <button
            bn-web-ui-button
            size="sm"
            [disabled]="selectedShieldPackage === planType.Advanced || false"
            [itemStyle]="selectedShieldPackage > planType.Advanced ? 'stroke' : 'primary'"
            [loading]="isUpdating()"
            [ngClass]="{ 'd-none': selectedShieldPackage === planType.Advanced }"
            (click)="onChoosePackage(planType.Advanced)">
            {{
              selectedShieldPackage === planType.Advanced
                ? 'Selected'
                : !getSelectedShieldId()
                  ? 'Select'
                  : selectedShieldPackage > planType.Advanced
                    ? 'Downgrade'
                    : 'Upgrade'
            }}
          </button>
        </div>
        <div class="cell">255</div>
        <div class="cell">10</div>
        <div class="cell">10</div>
        <div class="cell p-0 d-flex flex-column justify-content-center">
          50M inc.
          @if (!userStore.hidePricing()) {
            <div class="text-50-regular text-dark-7">$0.65/million overage</div>
          }
        </div>
        <div class="cell">Extensive</div>
        <div class="cell">AI insights</div>
        <div class="cell">Non-branded</div>
        <div class="cell">512KB</div>
        <div class="cell">Simple bots</div>
        <div class="cell">
          6 managed lists<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            [tooltip]="advancedManagedLists" />
        </div>
        <div class="cell">5 lists, 5k entries</div>
        <div class="cell">CSAM, AV</div>
        <div class="cell p-0 d-flex flex-column justify-content-center">
          500K inc.
          @if (!userStore.hidePricing()) {
            <div class="text-50-regular text-dark-7">$0.65/million overage</div>
          }
        </div>
        <div class="cell">10 endpoints</div>
        <div class="cell">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell last-item">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
      </div>
      <div
        class="col"
        [ngClass]="{ selected: selectedShieldPackage === planType.Business }">
        <div
          class="align-items-center header-cell"
          [ngClass]="{ selected: selectedShieldPackage === planType.Business }">
          <div class="position-relative w-100">
            @if (selectedShieldPackage === planType.Business) {
              <bn-web-ui-badge
                color=""
                contentClass="position-absolute start-50 translate-middle-x shield-plan-selected-badge"
                >Selected</bn-web-ui-badge
              >
            }
          </div>
          <p class="text-400-semi-bold mb-0">Business</p>
          <div class="mb-3">
            @if (!userStore.hidePricing()) {
              <span class="pricing">$99</span>
            }
            @if (!userStore.hidePricing()) {
              <div class="text-100-regular text-dark-7 pricing-per-month">month / per pull zone</div>
            }
          </div>
          <button
            bn-web-ui-button
            size="sm"
            [itemStyle]="selectedShieldPackage > planType.Business ? 'stroke' : 'primary'"
            [loading]="isUpdating()"
            [ngClass]="{ 'd-none': selectedShieldPackage === planType.Business }"
            (click)="onChoosePackage(planType.Business)">
            {{
              selectedShieldPackage === planType.Business
                ? 'Selected'
                : !getSelectedShieldId()
                  ? 'Select'
                  : selectedShieldPackage > planType.Business
                    ? 'Downgrade'
                    : 'Upgrade'
            }}
          </button>
        </div>
        <div class="cell">255</div>
        <div class="cell">25</div>
        <div class="cell">25</div>
        <div class="cell p-0 d-flex flex-column justify-content-center">
          250M inc.
          @if (!userStore.hidePricing()) {
            <div class="text-50-regular text-dark-7">$0.60/million overage</div>
          }
        </div>
        <div class="cell">Extensive</div>
        <div class="cell">AI insights</div>
        <div class="cell">Non-branded</div>
        <div class="cell">1MB</div>
        <div class="cell">Complex bots</div>
        <div class="cell">
          15 managed lists<fa-icon
            class="ms-1 icon-light cursor-pointer"
            containerClass="m-1"
            icon="circle-question"
            [tooltip]="businessManagedLists" />
        </div>
        <div class="cell">10 lists, 15k entries</div>
        <div class="cell">CSAM, AV</div>
        <div class="cell p-0 d-flex flex-column justify-content-center">
          2.5M inc.
          @if (!userStore.hidePricing()) {
            <div class="text-50-regular text-dark-7">$0.60/million overage</div>
          }
        </div>
        <div class="cell">50 endpoints</div>
        <div class="cell">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
        <div class="cell">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
        <div class="cell last-item">
          <fa-icon
            class="icon-light"
            icon="circle-xmark" />
        </div>
      </div>
      <div
        class="col"
        [ngClass]="{ selected: selectedShieldPackage === planType.Enterprise }">
        <div
          class="align-items-center header-cell border-right"
          [ngClass]="{ selected: selectedShieldPackage === planType.Enterprise }">
          <div class="position-relative w-100">
            @if (selectedShieldPackage === planType.Enterprise) {
              <bn-web-ui-badge
                color=""
                contentClass="position-absolute start-50 translate-middle-x shield-plan-selected-badge"
                >Selected</bn-web-ui-badge
              >
            }
          </div>
          <p class="text-400-semi-bold mb-3">Enterprise</p>
          <button
            bn-web-ui-button
            itemStyle="stroke"
            size="sm"
            [loading]="isUpdating()"
            [ngClass]="{ 'd-none': selectedShieldPackage === planType.Enterprise }"
            (click)="onContactSupportClick()">
            Contact Us
          </button>
        </div>
        <div class="cell border-right">255</div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">Extensive</div>
        <div class="cell border-right">AI insights</div>
        <div class="cell border-right">Non-branded</div>
        <div class="cell border-right">2MB+</div>
        <div class="cell border-right">Complex bots</div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="infinity" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
        <div class="cell border-right">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
        <div class="cell border-right last-item">
          <fa-icon
            class="icon-dark"
            icon="circle-check" />
        </div>
      </div>
    </div>
  </div>
</bn-web-ui-card>

<ng-template #advancedManagedLists>
  <ul>
    <li>- VPN Providers</li>
    <li>- Common Datacenters</li>
    <li>- TOR Exit Nodes</li>
    <li>- NETMOUNTAINS</li>
    <li>- FireHOL L1</li>
    <li>- AbuseIPDB</li>
  </ul>
</ng-template>

<ng-template #businessManagedLists>
  <ul>
    <li>- 6 in Advanced</li>
    <li>- Known Botnets L1</li>
    <li>- FireHOL L2</li>
    <li>- IPSum</li>
    <li>- Blocklist DE</li>
    <li>- ThreatFox</li>
    <li>- Emerging Threats</li>
    <li>- BotScout</li>
    <li>- StopForumSpam</li>
    <li>- SpamHaus DROP</li>
  </ul>
</ng-template>

<ng-template #enterpriseManagedLists>
  <ul>
    <li>- 6 in Advanced</li>
    <li>- 9 in Business</li>
    <li>- Known Botnets L2</li>
    <li>- CINS Army</li>
    <li>- Free Proxy List</li>
    <li>- Paid Proxy List</li>
    <li>- OTX AlienVault</li>
  </ul>
</ng-template>
